import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class ArrowElement extends PolygonMapItem {
    public override TypeName: string = "Arrow";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";
    
    constructor(formGroup: FormGroup) {
        super(formGroup, "Arrow");
        
       
    }

    override default(): ArrowElement {
        this.points = [
            { x: 0, y: -1.5 },    // Bottom left of arrow shaft
            { x: 4, y: -1.5 },    // Bottom right of arrow shaft
            { x: 4, y: -2.5 },    // Bottom of arrow head
            { x: 5, y: 0 },       // Arrow tip
            { x: 4, y: 2.5 },     // Top of arrow head
            { x: 4, y: 1.5 },     // Top right of arrow shaft
            { x: 0, y: 1.5 }      // Top left of arrow shaft
        ];
        this.formGroup.patchValue({
            Name: '',
            width: 5,
            height: 3
        });
        return this;
    }

    override clone(): ArrowElement {
        return new ArrowElement(
           this.formGroup
        );
    }

    override toJSON(): object {
        return {
            ...super.toJSON(),
            type: 'arrow'
        };
    }

    override fromJSON(json: any): void {
        if (json.type === 'arrow') {
            super.fromJSON(json);
        }
    }


    override updateForm(): void {
        super.updateForm();
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        
        return [
            ...super.getPropertyMetadata(),
            
        ];
    }
}
